import { useFormValues } from '@retainerclub/hooks';
import FieldContainer from '../../../../shared/FormElements/FieldContainer/FieldContainer';
import RcSelect from '../../../../shared/FormElements/Selects/RcSelect';

const upperArchFitOptions = [
  { id: 'upper_too_tight', name: 'Too tight' },
  { id: 'upper_too_loose', name: 'Too loose' },
  { id: 'upper_rubs_on_gums', name: 'Rubs on gums' },
  { id: 'upper_other', name: 'Other (Include specific notes in next section)' },
];

const lowerArchFitOptions = [
  { id: 'lower_too_tight', name: 'Too tight' },
  { id: 'lower_too_loose', name: 'Too loose' },
  { id: 'lower_rubs_on_gums', name: 'Rubs on gums' },
  { id: 'lower_other', name: 'Other (Include specific notes in next section)' },
];

function WarrantyFormConditionalFit() {
  const { arch } = useFormValues();

  return (
    <>
      {arch === 'upper' && (
        <FieldContainer
          name="upperArchFit"
          label="How does the top retainer fit?"
          required={true}
        >
          <RcSelect
            name="upperArchFit"
            data={upperArchFitOptions}
            clearable={false}
          />
        </FieldContainer>
      )}

      {arch === 'lower' && (
        <FieldContainer
          name="lowerArchFit"
          label="How does the bottom retainer fit?"
          required={true}
        >
          <RcSelect
            name="lowerArchFit"
            data={lowerArchFitOptions}
            clearable={false}
          />
        </FieldContainer>
      )}

      {arch === 'both' && (
        <>
          <FieldContainer
            name="upperArchFit"
            label="How does the top retainer fit?"
            required={true}
          >
            <RcSelect
              name="upperArchFit"
              data={upperArchFitOptions}
              clearable={false}
            />
          </FieldContainer>
          <FieldContainer
            name="lowerArchFit"
            label="How does the bottom retainer fit?"
            required={true}
          >
            <RcSelect
              name="lowerArchFit"
              data={lowerArchFitOptions}
              clearable={false}
            />
          </FieldContainer>
        </>
      )}
    </>
  );
}

export default WarrantyFormConditionalFit;
